import { PortableText } from "@portabletext/react"
import React from "react"
import Figure from "./Figure"

const components = {
  types: {
    figure: Figure,
  },
}

const BlockContent = ({ value }) => (
  <PortableText value={value} components={components} />
)

export default BlockContent
